export const REGION_COOKIE_NAME = 'storefront-region'
export const REGION_COOKIE_MAX_AGE = 60 * 60 * 24 * 365

export function readSavedRegion(
  cookies: string,
  supportedRegions: readonly string[],
): string | null {
  const prefix = `${REGION_COOKIE_NAME}=`
  const cookie = cookies.split(';').find((entry) => entry.trim().startsWith(prefix))
  if (!cookie) return null

  try {
    const slug = decodeURIComponent(cookie.trim().slice(prefix.length))
    return supportedRegions.includes(slug) ? slug : null
  } catch {
    return null
  }
}
